import { useAuthStore } from '@/stores/authStore.js'
import { api } from '@/api/ApiGateway.js'
import { echoes } from '@/composables/echo/useEchoes.js'

export function useFileDownload()
{
	const authStore = useAuthStore();

	async function downloadFile(p_url, p_params = {}, p_file_name, p_onsuccess, p_onerror)
	{
		try
		{
			//If you wanted to pull the file name out of the content-disposition header you need
			// to add 'content-disposition' to the exposed headers in gateway/config/cors.php

			const headers = {}
			headers['Authorization'] = `Bearer ${authStore.rawJwt}`;
			headers['x-client-user-id'] = authStore.getAuth?.user()?.id;
			headers['x-jwt-version-code'] = authStore.getAuth?.user()?.jwt_version_code;
			headers['X-Socket-ID'] = echoes.socketId();

			const response = await api.axiosInstance.get(p_url, {
				p_params,
				responseType: 'blob',
				headers: headers
			});
			if (import.meta.env.VITE_ENV === 'dev') console.log("headers", response.headers)

			const blob = new Blob([response.data], {
				type: response.headers['content-type'],
			});
			const objectUrl = window.URL.createObjectURL(blob);

			const a = document.createElement('a');
			a.href = objectUrl;
			a.download = p_file_name;
			document.body.appendChild(a);
			a.click();
			a.remove();
			window.URL.revokeObjectURL(objectUrl);

			if (p_onsuccess) p_onsuccess(response);
		}
		catch(err)
		{
			let errs = [];

			if (err.response?.data instanceof Blob)
			{
				const text = await err.response.data.text()
				const data = JSON.parse(text)
				if (import.meta.env.VITE_ENV === 'dev') console.log('downloadFile blob:', data)

				let errs = [];
				if (data['errors'])
				{
					errs = data['errors'];
				}

				const auth_error = errs.find((p_item) => p_item['status'] === 403);

				p_onerror(data, errs, auth_error ? true : false);
			}
			else if (err.response?.data)
			{
				if (import.meta.env.VITE_ENV === 'dev') console.log('downloadFile error:', err)
				if (err.response.data['errors'])
				{
					errs = err.response.data['errors'];
				}

				const auth_error = errs.find((p_item) => p_item['status'] === 403);

				p_onerror(err.response?.data, errs, auth_error)
			}
			else
			{
				if (import.meta.env.VITE_ENV === 'dev') console.log('downloadFile error:', err)
				p_onerror(err, errs, false)
			}
		}

	}

	return { downloadFile }
}